export var ScrollDirections;
(function (ScrollDirections) {
    ScrollDirections["vertical"] = "vertical";
    ScrollDirections["horizontal"] = "horizontal";
})(ScrollDirections || (ScrollDirections = {}));
export var DataSetsAttributes;
(function (DataSetsAttributes) {
    DataSetsAttributes["reactScrollPage"] = "react-scroll-page";
    DataSetsAttributes["reactScrollPageIndex"] = "react-scroll-page-index";
})(DataSetsAttributes || (DataSetsAttributes = {}));
